import React from 'react';

export const Warning: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 8.69999V6.36249"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.99938 10.5781C7.91313 10.5781 7.84313 10.6481 7.84375 10.7344C7.84375 10.8206 7.91375 10.8906 8 10.8906C8.08625 10.8906 8.15625 10.8206 8.15625 10.7344C8.15625 10.6481 8.08625 10.5781 7.99938 10.5781"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.26798 3.08687L14.0549 11.4644C14.6111 12.4381 13.908 13.65 12.7867 13.65H3.21298C2.0911 13.65 1.38798 12.4381 1.94485 11.4644L6.73173 3.08687C7.29235 2.105 8.70735 2.105 9.26798 3.08687Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
